import React, { useContext, useState } from 'react';
import FormModalFormatter, { IFormModalFormatterProps } from './FormModalFormatter';
import getIn from '../../connectedForm/utils/getIn';
import ViewContext from '../../Context/ViewContext';

const LazyProductForm = React.lazy(() => import('../../../views/product/ProductForm'));

const ProductFormModalFormatter = ({ value, dependentValues }: IFormModalFormatterProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const idValue = getIn(dependentValues.rowData, dependentValues.options?.entityId);

  return (
    <FormModalFormatter modalOpen={modalOpen} setModalOpen={setModalOpen} value={value}>
      <LazyProductForm
        forceReadOnly={true}
        onClose={() => setModalOpen(false)}
        pageView={true}
        match={{ params: { id: idValue } }}
        overrideParams={{ id: idValue }}
        temporaryDefault={false}
      />
    </FormModalFormatter>
  );
};

export default ProductFormModalFormatter;
